{
  "core.email": "Email",
  "core.name": "Name",
  "core.phone": "Mobile number",
  "core.fullName": "Full name",
  "core.firstName": "First name",
  "core.lastName": "Last name",
  "core.url": "Journey traveller URL",
  "core.or": "or",
  "core.and": "and",
  "core.cancel": "Cancel",
  "core.confirm": "Confirm",
  "core.save": "Save",
  "core.edit": "Edit",
  "core.duplicate": "Duplicate",
  "core.delete": "Delete",
  "core.remove": "Remove",
  "core.rename": "Rename",
  "core.yes": "Yes",
  "core.no": "No",
  "core.back": "Back",
  "core.continue": "Continue",
  "core.close": "Close",
  "core.not_set": "Not set",
  "core.search": "Search",
  "core.password": "Password",
  "core.add": "Add",
  "core.view": "View",
  "core.update": "Update",
  "core.filter": "Filter",
  "core.preview": "Preview",
  "core.open": "Open",
  "core.learnMore": "Learn more",
  "core.fileConverting": "File is being converted for preview",
  "core.user": "User",
  "core.active": "Active",
  "core.jqQuery": "./jq Query",

  "core.comparator.is": "Is...",
  "core.comparator.not_is": "Is not...",
  "core.comparator.any_of": "Is any of...",
  "core.comparator.none_of": "Is none of...",
  "core.comparator.after": "After",
  "core.comparator.on": "On",
  "core.comparator.before": "Before",

  "core.comparator.starts": "Starts with...",
  "core.comparator.not_starts": "Does not start with...",
  "core.comparator.contains": "Contains",
  "core.comparator.not_contains": "Does not contain",
  "core.comparator.is_rated_by": "Is rated by...",
  "core.comparator.not_is_rated_by": "Is not rated by...",
  "core.comparator.is_none": "No rating",
  "core.comparator.today": "Today",
  "core.comparator.yesterday": "Yesterday",
  "core.comparator.is_empty": "Is empty",
  "core.comparator.is_not_empty": "Is not empty",
  "core.comparator.gt": "More than",
  "core.comparator.between": "Between",
  "core.comparator.eq": "Exactly",
  "core.comparator.lt": "Less than",
  "core.comparator.empty": "Has no value",
  "core.comparator.not_empty": "Has value",
  "core.comparator.contains_multi": "Contains",

  "core.errors.generic": "Something went wrong. Please contact 50skills.",

  "core.language.en": "English",
  "core.language.is": "Icelandic",
  "core.language.pl": "Polish",
  "core.language.no": "Norwegian",
  "core.language.sv": "Swedish",
  "core.language.fr": "French",

  "core.max": "Max",
  "core.min": "Min",
  "core.median": "Median",
  "core.mean": "Mean",
  "core.q1": "Q1",
  "core.q3": "Q3",
  "core.outliers": "Outliers"
}
